import React, { useContext, useRef, useEffect, useState } from "react";
import ShapesComp from "../BasicShapes";
import MyContext from "../../../context/MyContext";
// import MyResize from '../myResize';
import Draggable from "react-draggable";
import ProjectContext from "../../../context/ProjectContext";

const ChangeableShapes = ({
  TickerStart,
  value,
  StackStore,
  TickerPosition,
  zInd,
  index,
  resizeRef,
  resizeRef2,
  AciveShapeColor,
  setAciveShapeColor,
  MultiDrag,
  setMultiDrag,
  Call_ScreenShot,
  setCall_ScreenShot,
}) => {
  const {
    CanvasDisplay,
    setLayersData,
    LayersData,
    EditorZoom,
    IsPressedShiftKey,
    seteditableObject,
  } = useContext(MyContext);
  const { slides, setslides } = useContext(ProjectContext);

  const [Dragging, setDragging] = useState(false);

  const dragref = useRef(null);

  const shapeRef = useRef(null);

  const locked = (e) => {
    e.target.previousSibling.style.display = "block";
    e.target.style.display = "none";
  };

  const Unlock = async (obj) => {
    await StackStore();

    const array = Array.from(LayersData);

    for (var i = 0; i < array.length; i++) {
      if (array[i].key === obj) {
        array[i].lock = false;
        array[i].layerlock = false;
        array[i].showDiv = true;
      }
    }
    setLayersData(array);
  };

  const LockShow = (e) => {
    e.target.nextSibling.style.display = "block";
    e.target.style.display = "none";
  };

  // const BasicShapeClick = (e, key) => {
  //     if (e.target.className !== "AniamteDrag") {
  //         const array = Array.from(LayersData);
  //         for (var i = 0; i < array.length; i++) {
  //             if (array[i].key === key) {
  //                 array[i].toolbar = true;
  //                 array[i].Editable = true;
  //             } else {
  //                 array[i].toolbar = false;
  //                 array[i].Editable = false;
  //             }
  //         }
  //         setLayersData(array);
  //     }
  // }

  var IsSetStateUpdate = false;
  const Dragger = (e, data) => {
    if (data.node.nextSibling) {
      IsSetStateUpdate = true;
      data.node.nextSibling.style.left = data.x + "px";
      data.node.nextSibling.style.top = data.y + "px";

      const newArray = Array.from(LayersData);

      let change = false;

      newArray.map((newvalue) => {
        if (newvalue.key === value.key) {
          if (newvalue.showDiv) {
            value.showDiv = false;
            change = true;
          }
        }
      });

      if (change) {
        setLayersData(newArray);
      }

      // const newArray = Array.from(LayersData);
      // let change = false;

      // for(let i = 0; i < newArray.length; i++)
      // {
      //     if(newArray[i].key === value.key)
      //     {
      //         if(newArray[i].waitSS)
      //         {
      //             newArray[i].waitSS = false;
      //             change = true;
      //         }
      //     }
      // }

      // if(change)
      // {
      //     const _slides = Array.from(slides);

      //     const active_slides = _slides.find(x => x.IsActive === true);

      //     active_slides.LayerData = newArray;

      //     setslides(_slides)
      //     setLayersData(newArray)
      // }
      //data.node.style.transform = `translate(${data.x}px, ${data.y}px) rotate(${value.rotateAngle}deg)`
    }
  };

  const DragEnd = async (e, data) => {
    //data.node.style.transform = `translate(${data.x}px, ${data.y}px) rotate(${value.rotateAngle}deg)`
    const newArray = Array.from(LayersData);
    for (var i = 0; i < newArray.length; i++) {
      if (newArray[i].key === value.key) {
        newArray[i].x = (data.x / EditorZoom) * 100;
        newArray[i].y = (data.y / EditorZoom) * 100;
        newArray[i].originalX = (data.x / EditorZoom) * 100;
        newArray[i].originalY = (data.y / EditorZoom) * 100;
        newArray[i].Editable = true;
        newArray[i].toolbar = true;
        newArray[i].waitSS = true;
        newArray[i].showDiv = true;
        IsSetStateUpdate = false;
      } else {
        newArray[i].Editable = false;
        newArray[i].toolbar = false;
        newArray[i].showDiv = false;

        if (newArray[i].type === "text") {
          newArray[i].edit = "false";
          if (newArray[i].FurtherSetting === true) {
            newArray[i].FurtherSetting = false;
          }
          if (newArray[i].Editable === true) {
            newArray[i].Editable = false;
          }
        }
      }
    }
    // const _slides = Array.from(slides);
    // const active_slides = _slides.find(x => x.IsActive === true);
    // active_slides.LayerData = newArray;

    // setTimeout(() => {

    //     if(!IsSetStateUpdate)
    //     {
    //         setslides(_slides)
    //     }

    // }, 7000);

    // if (!Call_ScreenShot) {
    //   setCall_ScreenShot(true);
    // }
    setLayersData(newArray);
  };

  const activeEdit = (params) => {
    if (!IsPressedShiftKey) {
      const newArray = Array.from(LayersData);
      for (var i = 0; i < newArray.length; i++) {
        if (newArray[i].key === value.key) {
          newArray[i].Editable = true;
          newArray[i].toolbar = true;
          newArray[i].showDiv = true;
        } else {
          newArray[i].Editable = false;
          newArray[i].toolbar = false;
          newArray[i].showDiv = false;
        }
      }
      setLayersData(newArray);
      //ShowPanelLeft
      seteditableObject({ showPanel: true, editableItem: value });
    }
  };

  const Activated = () => {
    if (MultiDrag.length > 1) {
      const arr = Array.from(MultiDrag);
      //setMultiDrag(arr);
      const array = Array.from(LayersData);
      for (var i = 0; i < array.length; i++) {
        if (array[i].key == value.key) {
          if (value.InMultiDrag === false) {
            arr.push(array[i]);
            array[i].InMultiDrag = true;
          } else {
            const index = arr.indexOf(value);

            if (index > -1) {
              // only splice array when item is found
              arr.splice(index, 1); // 2nd parameter means remove one item only
            }
            value.InMultiDrag = false;
            var element = document.getElementsByClassName(
              "Inner-" + value.AnimationId
            );
            if (element.length > 0) {
              element.classList.remove("disableEvents");
            }
          }
        }
      }
      if (arr.length === 1) {
        setMultiDrag([]);
        const array = Array.from(LayersData);
        for (var i = 0; i < array.length; i++) {
          if (array[i].key === arr[0].key) {
            array[i].showDiv = true;
            array[i].Editable = true;
          }
        }
      } else {
        setMultiDrag(arr);
      }

      setLayersData(array);
    } else {
      let arr = [];
      const array = Array.from(LayersData);
      for (var i = 0; i < array.length; i++) {
        if (array[i].key !== value.key) {
          if (array[i].Editable == true) {
            arr.push(array[i]);
            array[i].Editable = false;
            array[i].showDiv = false;
          }
        } else {
          arr.push(array[i]);
        }
      }
      if (arr.length > 1) {
        setMultiDrag(arr);
        for (const itr of array) {
          for (const atr of arr) {
            if (atr.key == itr.key) {
              itr.InMultiDrag = true;
            }
            atr.toolbar = false;
          }
        }
        setLayersData(array);
      } else {
        for (var i = 0; i < array.length; i++) {
          if (array[i].key == value.key) {
            array[i].toolbar = true;
            array[i].Editable = true;
          } else {
            array[i].Editable = false;
            array[i].showDiv = false;
          }
        }
        setLayersData(array);
        arr = [];
      }
    }
  };

  useEffect(() => {
    if (dragref.current) {
      dragref.current.style.transform = `translate(${
        (value.x * EditorZoom) / 100
      }px, ${(value.y * EditorZoom) / 100}px) rotate(${value.rotateAngle}deg)`;
    }
  }, [value.rotateAngle, dragref.current]);
  const generateClassWithShift = () => {
    if (Dragging) {
      if (value.InMultiDrag) {
        return "AniamteDrag disableEvents checker";
      } else {
        return "AniamteDrag checker";
      }
    } else {
      if (value.InMultiDrag) {
        return "AniamteDrag dotedBorder disableEvents checker";
      } else {
        return "AniamteDrag dotedBorder checker";
      }
    }
  };
  const generateClassWithoutShift = () => {
    if (Dragging) {
      if (value.InMultiDrag) {
        return "AniamteDrag checker";
      } else {
        return "AniamteDrag checker";
      }
    } else {
      if (value.InMultiDrag) {
        return "AniamteDrag dotedBorder checker";
      } else {
        return "AniamteDrag dotedBorder checker";
      }
    }
  };
  return (
    <>
      {value.lock === false && value.lock === false && value.opc === 1 && (
        <>
          {/* {!value.Editable && CanvasDisplay && (
                <MyResize Editable={value.Editable} resizeRef={shapeRef} type={value.type} values={value} />
            )} */}

          {!value.Editable && CanvasDisplay && (
            <Draggable
              defaultClassName={
                IsPressedShiftKey
                  ? generateClassWithoutShift()
                  : generateClassWithShift()
              }
              onMouseDown={(e) => {
                if (e.shiftKey) {
                  Activated();
                  return false;
                }
              }}
              onStart={(e) => {
                if (e.shiftKey) {
                  return false;
                } else {
                  setMultiDrag([]);
                  setDragging(true);
                  seteditableObject({ showPanel: true, editableItem: value });
                }
              }}
              onDrag={(event, data) => Dragger(event, data)}
              onStop={(event, data) => {
                DragEnd(event, data);
                setDragging(false);
              }}
              cancel={".resizable-handler , .square , .rotate"}
              position={{
                x: (value.x * EditorZoom) / 100,
                y: (value.y * EditorZoom) / 100,
              }}
            >
              <div
                id={`Inner-${value.AnimationId}`}
                ref={dragref}
                onClick={activeEdit}
                style={{
                  // display: (!CanvasDisplay ? 'none' :
                  //     TickerStart ? (value.startPositionOnTimeline <= TickerPosition && (value.startPositionOnTimeline + value.widthOnTimeline) >= TickerPosition) ?
                  //         'inline-block' : 'none' : (value.startPositionOnTimeline + value.startTransitionWidth <= TickerPosition && (value.startPositionOnTimeline + value.widthOnTimeline - value.startTransitionWidth) >= TickerPosition) ? 'inline-block' : 'none'),
                  display: !CanvasDisplay
                    ? value.player
                      ? "inline-block"
                      : "none"
                    : value.startPositionOnTimeline <= TickerPosition &&
                      value.startPositionOnTimeline + value.widthOnTimeline >=
                        TickerPosition
                    ? "inline-block"
                    : "none",
                  height: Math.round((value.height * EditorZoom) / 100),
                  width: Math.round((value.width * EditorZoom) / 100),
                }}
              ></div>
            </Draggable>
          )}

          <div
            id={`Outer-${value.AnimationId}`}
            className={
              "changer EditStart " +
              (value.Editable ? " RectBorder " : "") +
              (!CanvasDisplay ? value.InClass + value.OutClass : "")
            }
            ref={!value.Editable ? shapeRef : resizeRef}
            style={{
              display: !CanvasDisplay
                ? value.player
                  ? "inline-block"
                  : "none"
                : value.startPositionOnTimeline <= TickerPosition &&
                  value.startPositionOnTimeline + value.widthOnTimeline >=
                    TickerPosition
                ? "inline-block"
                : "none",
              border: value.lock == true ? "1px dashed #37484f" : "",
              height: Math.round((value.height * EditorZoom) / 100),
              width: Math.round((value.width * EditorZoom) / 100),
              zIndex: !value.lock ? zInd : 1500 + zInd,
              transform: CanvasDisplay ? `rotate(${value.rotateAngle}deg)` : "",
              VendorAnimationDuration: ".5s",
              left: Math.round((value.x * EditorZoom) / 100),
              top: Math.round((value.y * EditorZoom) / 100),
              cursor: value.lock == true ? "default" : "grab",
            }}
          >
            {/* {value.Editable === true && CanvasDisplay && (
                    <MyResize Editable={value.Editable} resizeRef={shapeRef} type={value.type} values={value} />
                )} */}
            {/* {!value.Editable && CanvasDisplay && (
                    <MyResize Editable={value.Editable} resizeRef={shapeRef} type={value.type} values={value} />
                )} */}
            <ShapesComp
              setLayersData={setLayersData}
              LayersData={LayersData}
              EditorZoom={EditorZoom}
              AciveShapeColor={AciveShapeColor}
              setAciveShapeColor={setAciveShapeColor}
              value={value}
              index={index}
              CanvasDisplay={CanvasDisplay}
              InLock={false}
            />
          </div>

          {value.showDiv === true && (
            <div
              id={`showDiv-${value.AnimationId}`}
              ref={resizeRef2}
              style={{
                VendorAnimationDuration: ".5s",
                cursor: value.lock == true ? "default" : "grab",
                transform: CanvasDisplay
                  ? `rotate(${value.rotateAngle}deg)`
                  : "",
                display: !CanvasDisplay
                  ? value.player && !value.startAtoZ
                    ? "inline-block"
                    : "none"
                  : value.startPositionOnTimeline <= TickerPosition &&
                    value.startPositionOnTimeline + value.widthOnTimeline >=
                      TickerPosition
                  ? "inline-block"
                  : "none",
                height: Math.round((value.height * EditorZoom) / 100),
                width: Math.round((value.width * EditorZoom) / 100),
                zIndex: !value.lock ? 1000 : 1100 + 50,
                border:
                  value.lock == true ? "1px dashed black" : "2px solid #15d0e9",
                left: Math.round((value.x * EditorZoom) / 100),
                top: Math.round((value.y * EditorZoom) / 100),
                position: "absolute",
              }}
            ></div>
          )}
        </>
      )}
      {value.lock === true && value.opc === 1 && (
        <>
          <div
            className="RectBorder"
            style={{
              width: (value.width * EditorZoom) / 100,
              height: (value.height * EditorZoom) / 100,
              position: "absolute",
              display: !CanvasDisplay
                ? value.player
                  ? "inline-block"
                  : "none"
                : value.startPositionOnTimeline <= TickerPosition &&
                  value.startPositionOnTimeline + value.widthOnTimeline >=
                    TickerPosition
                ? "inline-block"
                : "none",
              zIndex: zInd,
              border: value.lock == true ? "1px dashed #37484f" : "",
              left: Math.round((value.x * EditorZoom) / 100),
              top: Math.round((value.y * EditorZoom) / 100),
              transform: `rotate(${value.rotateAngle}deg)`,
            }}
          >
            <ShapesComp
              value={value}
              index={index}
              CanvasDisplay={CanvasDisplay}
              InLock={true}
            />
            <div data_set="lock_object" className="LockTop">
              <div className="LockInnerBorder">
                <span
                  className="material-icons material-icons-outlined Lockback"
                  tabIndex="0"
                  onMouseOver={LockShow}
                >
                  lock
                </span>
                <span
                  className="material-icons material-icons-outlined unlock "
                  tabIndex="0"
                  onMouseOut={locked}
                  onClick={() => Unlock(value.key)}
                >
                  lock_open
                </span>
              </div>
            </div>
          </div>
        </>
      )}
    </>
  );
};
export default ChangeableShapes;
